export default "__VITE_ASSET__c3bfc4f0__"